import { Component } from '@angular/core';
import {AlertController, NavController, NavParams, ToastController} from 'ionic-angular';
import {AlertsService} from "../../services/alerts.service";
import { Storage } from '@ionic/storage';
import { Dialogs } from '@ionic-native/dialogs';
import {RealtimePage} from "../realtime/realtime";
import {HistoricPage} from "../historic/historic";
import {AlertsPage} from "../alerts/alerts";
import {LoginPage} from "../login/login";
import {AuthService} from "../../services/auth.service";
import {SocketService} from "../../services/socket.service";
import {UtilsService} from "../../services/utils.service";
import {SensorUtilService} from "../../services/sensors.service";
import {AssetsService} from "../../services/assets.service";
 import { SMS } from '@ionic-native/sms';
 import { Platform } from 'ionic-angular';
//import { SMS } from '@awesome-cordova-plugins/sms/ngx';
@Component({
  selector: 'page-main',
  templateUrl: 'main.html'
})
export class MainPage{

  private asset: any = {};
  private alerts: any = [];
  private alertCount : number = 0;
  private sim: string = '';
  private deviceType: string = '';
  private start: string = '';
  private stop: string = '';
  private canGoBack :boolean = false;
  private isBrowser : boolean =false;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private socketService: SocketService,
              private alertCtrl: AlertController,
              private utilsService: UtilsService,
              private sensorUtilService: SensorUtilService,
              private assetsService: AssetsService,
              public storage: Storage,
              private dialogs: Dialogs,
              private authService: AuthService,
              private alertsService: AlertsService,
              private toastCtrl: ToastController,
              private sms: SMS,
              platform: Platform) {
    //Getting the asset object from navigation parameters
    this.asset = navParams.get('asset');
    this.canGoBack = navParams.get('canGoBack');
    if (platform.is('core')) {
      this.isBrowser =true;
    } else {
     this. isBrowser =false;
    }
    //console.log(this.asset);
  }

  ngOnInit() {
    //Getting alert count
    this.loadAlerts();

    this.socketService.on('newMsg').subscribe((data:any)=>{
      if(this.asset._id == data._id){
        data.driver = this.asset.driver;
        this.asset = data;
        let coordinates = [];
        let result = [];

        if (this.asset.rt && this.asset.rt.loc && this.asset.rt.loc.coordinates && this.asset.rt.loc.coordinates[1] && this.asset.rt.loc.coordinates[0]) {
          coordinates.push([this.asset.rt.loc.coordinates[0], this.asset.rt.loc.coordinates[1]])
        } else {
          coordinates.push([0, 0])
        }



        if (coordinates.length > 0){
          this.utilsService.getAddress(coordinates).subscribe(data => {
            let res = data.BND.BatchResults;

            if (res.length > 0) {
              for(let value of res){
                if (value.Elements.count > 0) {
                  let element = value.Elements.Element[0];
                  let address = this.utilsService.format(element);
                  result.push(address);
                }
                else
                  result.push("Not available")
              }
            }


            if (this.asset.rt && this.asset.rt.loc && this.asset.rt.loc.coordinates && this.asset.rt.loc.coordinates[1] && this.asset.rt.loc.coordinates[1] !== 0 && this.asset.rt.loc.coordinates[0] && this.asset.rt.loc.coordinates[0] !== 0)
              this.asset.address = result[0];
            this.getAssetSensors(this.asset);
            this.asset = this.assetsService.getSingleAssetIcons(this.asset);

          });
        }

      }
    });


  }


  getAssetSensors(asset){
    let sensors = asset.sensors;
    asset.sensorData = [];
    if(sensors.length > 0){


      for(let sensor of sensors){
        let sensorName = sensor.name;
        sensor.value_pourcent =null;
        let src = sensor.src.slice(sensor.src.lastIndexOf('.') + 1);
        if (sensor.type && sensor.src && asset.rt &&asset.rt.io && Number.isFinite(asset.rt.io[src])) {
          let realVal = asset.rt.io[src];
          if (this.sensorUtilService.getSensorFamily(sensor.type) === "ANALOGIC") {
            if (Number.isFinite(sensor.minSrc) && Number.isFinite(sensor.maxSrc) && Number.isFinite(sensor.min) && Number.isFinite(sensor.max)) {
              realVal = this.sensorUtilService.getRealSensorValue(asset.rt.io[src], sensor.minSrc, sensor.maxSrc, sensor.min, sensor.max, sensor.gaps, sensor);
            }
            
if(sensor.type == "FUEL_LEVEL")
sensor.value_pourcent =
            (realVal / sensor.max) * 100;

            if (Number.isFinite(realVal))
              asset.sensorData.push({
                name: sensorName,
                type: sensor.type,
                family: sensor.family,
                unit: sensor.unit,
                value: parseFloat(realVal.toFixed(2)),
                value_pourcent:sensor.value_pourcent ? parseFloat(sensor.value_pourcent.toFixed(2)) :null
              });
          }
          if (this.sensorUtilService.getSensorFamily(sensor.type) === "BINARY") {
            
            asset.sensorData.push({
              name: sensorName,
              type: sensor.type,
              family: sensor.family,
              ON: sensor.ON,
              OFF: sensor.OFF,
              value:realVal,
              status: realVal === sensor.ON ? this.sensorUtilService.getSensorsTypes().STATUS[sensor.type].enabled
              :  this.sensorUtilService.getSensorsTypes().STATUS[sensor.type].disabled,
              class: realVal === sensor.ON ? "is-on" : "is-off"
            });
          }
        }
      }
    }
  }


  loadAlerts(){
    this.storage.get('token').then(token => {

      this.alertsService.getAlerts({
        query : {
          '_assetId' : this.asset._id
        },
        options: {
          populate: [
            {
              path: '_assetId',
              select:   '_id name type'
            },
            {
              path: '_alertConfig',
              select: 'config name type'

            }
          ],
          sortBy: {start_dt: -1}
        }
      },100, 0).subscribe(alerts => {
        this.alerts = alerts.result;
        if(this.alerts.length > 0){
          for(let alert of this.alerts){
            if(!alert.ack){
              this.alertCount += 1;
            }
          }
        }
      })
    });
  }

  presentToast() {
    let toast = this.toastCtrl.create({
      message: 'Vérifier le mot de passe de l\'appareil !',
      position: 'bottom',
      showCloseButton: true
    });

    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    toast.present();
  }

  sendMessage(asset) {
    this.storage.get('deviceParams').then((deviceParams)=> {
      this.assetsService.getSingleAsset({query: {_id: asset._id}, options: { populate: [{path: "_dev", populate: {path:"model", model:"device_type"}}]}})
        .subscribe(data => {
          this.sim = data.result[0]._dev.sim;
          this.deviceType = data.result[0]._dev.model;
          if(deviceParams.username && deviceParams.password && data && data.result[0] && data.result[0]._dev
            && data.result[0]._dev.model&& data.result[0]._dev.model.config&& data.result[0]._dev.model.config.commands){
            this.start = data.result[0]._dev.model.config.commands.start;
            this.stop = data.result[0]._dev.model.config.commands.stop;



            this.start = this.start.replace("[userName]",  deviceParams.username);
            this.start = this.start.replace("[userPass]", deviceParams.password);

            this.stop = this.stop.replace("[userName]",  deviceParams.username);
            this.stop = this.stop.replace("[userPass]",  deviceParams.password);
      //CONFIGURATION
      var options = {
        replaceLineBreaks: true, // true to replace \n by a new line, false by default
        android: {
        //    intent: 'INTENT'  // send SMS with the native android SMS messaging
            intent: '' // send SMS without opening any other app, require : android.permission.SEND_SMS and android.permission.READ_PHONE_STATE
        }
    };
            this.dialogs.confirm(asset.name, this.sim, ['Start', 'Stop', 'Cancel']).then((res) => {
              if (res.toString() == '1') {
                this.sms.send(this.sim,  this.start, options)
             //  this.sms.send(this.sim,  this.start)
              } else if (res.toString() == '2') {
                 this.sms.send(this.sim,  this.stop, options)
              //  this.sms.send(this.sim,  this.stop)
              }else if(res.toString() == '3'){
              }
            }).catch(e => console.log('Error displaying dialog', e));
          }else{
            this.presentToast();
          }
        })
    })
  }

  goBack(){
    // Go back to assets
    if(this.canGoBack){
      this.navCtrl.pop();
    }
  }
  goHisto(){
    // Go back to assets
    this.navCtrl.push(HistoricPage, {asset : this.asset, canGoBack: this.canGoBack}, {animate: true, direction: 'forward'}).then(()=>{
      const index = this.navCtrl.getActive().index;
      this.navCtrl.remove(index-1);
    });
  }
  showAlerts(asset){
    this.navCtrl.push(AlertsPage, {asset: this.asset, alerts: this.alerts});
  }
  goRT(){
    this.navCtrl.push(RealtimePage, {asset : this.asset, canGoBack: this.canGoBack}, {animate: true, direction: 'forward'}).then(()=>{
      const index = this.navCtrl.getActive().index;
      this.navCtrl.remove(index-1);
    });
  }

  logout(){
    this.authService.disconnect().then(()=>{
      this.navCtrl.setRoot(LoginPage);
    })
  }

  setting(){
    let alert = this.alertCtrl.create({
      title: 'Mot de passe de l\'appareil',
    });

    this.storage.get('deviceParams').then((deviceParams)=>{
      alert.addInput({
        name: 'deviceUsername',
        placeholder: 'Login',
        type: 'string',
        value: deviceParams.username
      })
      alert.addInput({
        name: 'devicePassword',
        placeholder: 'Mot de passe',
        type: 'password',
        value: deviceParams.password
      })
      alert.addButton( {
        text: 'Valider',
        handler: data => {
          this.storage.set('deviceParams', {username: data.deviceUsername, password : data.devicePassword})
        }
      })
      alert.addButton( {
        text: 'Annuler',
        role: 'cancel',
        handler: data => {
          console.log('Cancel clicked');
        }
      })

    });

    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/main/main.ts